export const START_YEAR = 1900;

export const months = [
  { value: 1, name: "January" },
  { value: 2, name: "February" },
  { value: 3, name: "March" },
  { value: 4, name: "April" },
  { value: 5, name: "May" },
  { value: 6, name: "June" },
  { value: 7, name: "July" },
  { value: 8, name: "August" },
  { value: 9, name: "September" },
  { value: 10, name: "October" },
  { value: 11, name: "November" },
  { value: 12, name: "December" },
];

export function getDaysInMonth(month: number, year: number): number {
  if (!month || !year) return 31;
  return new Date(year, month, 0).getDate();
}

export function createDateFromValues(
  day: string,
  month: string,
  year: string
): Date | string | null {
  if (!day || !month || !year) return null;
  const dayNum = parseInt(day, 10);
  const monthNum = parseInt(month, 10);
  const yearNum = parseInt(year, 10);
  if (isNaN(dayNum) || isNaN(monthNum) || isNaN(yearNum)) return null;
  const formattedMonth = monthNum < 10 ? `0${monthNum}` : `${monthNum}`;
  const formattedDay = dayNum < 10 ? `0${dayNum}` : `${dayNum}`;
  return `${formattedDay}/${formattedMonth}/${yearNum}`;
}

export function validateAndAdjustDay(
  day: string,
  month: string,
  year: string
): string {
  if (!day || !month || !year) return day;
  const dayNum = parseInt(day, 10);
  const monthNum = parseInt(month, 10);
  const yearNum = parseInt(year, 10);
  if (isNaN(dayNum) || isNaN(monthNum) || isNaN(yearNum)) return day;
  const maxDays = getDaysInMonth(monthNum, yearNum);
  return dayNum > maxDays ? maxDays.toString() : day;
}
